/**
 * Audio Description Manager - 可复用的音频描述组件
 * 用于管理视频播放时的时间轴描述功能
 */
class AudioDescriptionManager {
  constructor(options = {}) {
    this.timeline = (options.timeline || []).sort((a, b) => a.time - b.time);
    this.currentIndex = 0;
    this.videoSelector = options.videoSelector;
    this.containerSelector = options.containerSelector;
    this.enableSpeech = options.enableSpeech !== false;
    this.speechLang = options.speechLang || 'zh-CN';
    
    this.video = null;
    this.descContainer = null;
    this.initialized = false;
  }

  /**
   * 初始化组件
   */
  init() {
    if (this.initialized) return;
    
    this.video = document.querySelector(this.videoSelector);
    this.descContainer = document.querySelector(this.containerSelector);
    
    if (!this.video || !this.descContainer) {
      console.warn('AudioDescriptionManager: Video or description container not found');
      return;
    }

    this.bindEvents();
    this.initialized = true;
  }

  /**
   * 绑定事件监听器
   */
  bindEvents() {
    this.video.addEventListener('timeupdate', () => {
      this.handleTimeUpdate();
    });

    // 视频重新开始时重置索引
    this.video.addEventListener('play', () => {
      if (this.video.currentTime === 0) {
        this.currentIndex = 0;
      }
    });
  }

  /**
   * 处理时间更新事件
   */
  handleTimeUpdate() {
    const currentTime = Math.floor(this.video.currentTime);
    const description = this.getCurrentDescription(currentTime);
    this.updateDescription(description);
  }

  /**
   * 根据当前时间获取描述
   */
  getCurrentDescription(currentTime) {
    while (this.currentIndex < this.timeline.length - 1 &&
           currentTime >= this.timeline[this.currentIndex + 1].time) {
      this.currentIndex++;
    }
    return this.timeline[this.currentIndex].text;
  }

  /**
   * 更新描述内容
   */
  updateDescription(text) {
    if (this.descContainer) {
      this.descContainer.textContent = text;
      if (this.enableSpeech) {
        this.speakText(text);
      }
    }
  }

  /**
   * 语音合成播报
   */
  speakText(text) {
    if ('speechSynthesis' in window) {
      // 停止之前的播报
      speechSynthesis.cancel();
      
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = this.speechLang;
      utterance.rate = 0.9; // 稍微慢一点，便于理解
      speechSynthesis.speak(utterance);
    }
  }

  /**
   * 销毁组件
   */
  destroy() {
    if (this.video) {
      this.video.removeEventListener('timeupdate', this.handleTimeUpdate);
      this.video.removeEventListener('play', this.handlePlay);
    }
    
    if ('speechSynthesis' in window) {
      speechSynthesis.cancel();
    }
    
    this.initialized = false;
  }

  /**
   * 更新时间轴数据
   */
  updateTimeline(newTimeline) {
    this.timeline = newTimeline.sort((a, b) => a.time - b.time);
    this.currentIndex = 0;
  }

  /**
   * 静态方法：创建多个实例
   */
  static createMultiple(instances) {
    return instances.map(config => {
      const manager = new AudioDescriptionManager(config);
      manager.init();
      return manager;
    });
  }
}

// 全局注册
window.AudioDescriptionManager = AudioDescriptionManager;